module.exports = __webpack_public_path__ + "img/flavour.ecbe295f.png";